module.exports = __webpack_public_path__ + "img/google.223721f9.png";